import PropTypes from 'prop-types';
import classNames from 'classnames';
import { compose } from 'recompose';
import { connect } from 'react-redux';

// Components
import Trans from '../Global/Translation';
import NavigationContainer from '../Global/NavigationContainer';
import { actionHandler } from '../../utilities/form/formUtils';

// Constants
import { stepComponents } from '../../constants/Steps';
import { getShowForProducts, getButtonVisible } from '../../utilities/section/sectionUtils';
import { replaceAll } from '../../utilities/common';

const FormActions = ({
  actionProps,
  dispatch,
  formActions,
  formParams,
  isValid,
  submitText,
  tracking,
  values,
  waitText,
  actionVariant,
  error,
  setFieldValue,
  translations,
  submitIcon,
  applyFormSubmitClass,
  currentProgress,
  btn,
  className,
  buttonPostClass,
  hideNext,
  formClassName,
  nextButtonType,
  nextButtonLinkUrl,
  nextButtonDivClassName
}) => {
  // Create new array including every buttons and variants which shouldn't be next to submit button
  const submitVariants = ['submit'];
  const actionsProps = actionProps ? getShowForProducts(actionProps, values).filter(
    actionProp => !(actionProp.variant && submitVariants.includes(actionProp.variant))
  ) : [];
  // Create new array including every buttons that should be next to submit button
  const actionsButtons = actionProps ? getShowForProducts(actionProps, values).filter(
    actionProp => actionProp.variant && submitVariants.includes(actionProp.variant)
  ) : [];

  const submitLabel = replaceAll(submitText, translations, values);

  const submitClass = classNames(
    tracking,
    {
      'form-submit': applyFormSubmitClass,
      'form-submit--primary': applyFormSubmitClass,
    },
    'button',
    'button--primary', {
      'button--loading': waitText,
      'button--arrow-wide': submitLabel === 'Gennemfør køb',
      [`button--${buttonPostClass}`]: buttonPostClass !== '',
    }
  );
  const actionsPropsClass = classNames(
    'actions__props', {
      [`actions__props--${actionVariant}`]: actionVariant,
    }
  );
  if (error) {
    return <div/>;
  }

  return (
    <div className={`form__actions ${formClassName}`}>

      {actionsProps.length > 0 &&
      <ul className={actionsPropsClass}>
        {actionsProps.map(actionProp => {
          const inputParams = {
            ...formParams,
            ...actionProp,
            values,
          };
          const InputComponent = stepComponents[actionProp.type];
          return (<InputComponent {...inputParams}/>);
        })
        }
      </ul>
      }

      <NavigationContainer 
        dispatch={dispatch}
        currentProgress={currentProgress}
        config={currentProgress.backButtonConfig}
        displayImage={currentProgress.displayImgSection}
        nextButtonStyle={ { display: getButtonVisible(hideNext, isValid) } }
        nextButtonClassName={submitClass}
        nextButtonOnClick={e => actionHandler(formActions, null, e, dispatch,
          { ...values, setFieldValue })}
        nextButtonRef={node => (btn = node)}
        type="submit"
        nextButtonDisabled={!isValid}
        nextButtonDataTealium={`{"link_text": "${submitLabel}"}`}
        nextButtonLabel={submitLabel}
        nextButtonLinkUrl={nextButtonLinkUrl}
        nextButtonSubmitIcon={submitIcon}
        nextButtonType={nextButtonType}
        nextButtonActionsButtons={actionsButtons}
        nextButtonLinkTracking={tracking}
        nextButtonLinkTranslations={translations}
        nextButtonDivClassName={nextButtonDivClassName}
      />

      {/* Loading Icon */}
      {waitText &&
      <div className="actions__loading">
        <Trans value={waitText}/>
      </div>
      }

    </div>
  );
};

export default compose(
  connect(state => {
    const {
      app: {
        error,
      },
      section: { packageData: { translations } },
    } = state;
    return {
      error,
      translations,
    };
  })
)(FormActions);

FormActions.defaultProps = {
  waitText: null,
  formActions: null,
  formParams: null,
  actionProps: [],
  tracking: ['tealiumSubmit'],
  actionVariant: '',
  setFieldValue: null,
  submitIcon: true,
  applyFormSubmitClass: true,
  btn: {},
  className: '',
  buttonPostClass: '',
  hideNext: false,
  formClassName: '',
};

FormActions.propTypes = {
  isValid: PropTypes.bool.isRequired,
  submitText: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  tracking: PropTypes.array,
  actionVariant: PropTypes.string,
  formParams: PropTypes.object,
  actionProps: PropTypes.array,
  formActions: PropTypes.array,
  waitText: PropTypes.string,
  error: PropTypes.bool.isRequired,
  setFieldValue: PropTypes.func,
  translations: PropTypes.object.isRequired,
  submitIcon: PropTypes.bool,
  applyFormSubmitClass: PropTypes.bool,
  currentProgress: PropTypes.object.isRequired,
  btn: PropTypes.object,
  className: PropTypes.string,
  buttonPostClass: PropTypes.string,
  hideNext: PropTypes.bool,
  formClassName: PropTypes.string,
  nextButtonType: PropTypes.string,
  nextButtonLinkUrl: PropTypes.string,
  nextButtonDivClassName: PropTypes.string,
};
